import { plaintextValidator, numberValidator } from '../fields';
import { getTranslatedText } from '@nile/components';

const config = { mandatory: true };

const durationMinMaxMap = {
  MINUTES: {
    min: 5
  },
  HOURS: {
    min: 1
  }
};

const loggedInUserScheduleValidation = (unit, intl) => {
  return {
    interval: numberValidator({
      ...config,
      optional: {
        greaterThanOrEqualTo: durationMinMaxMap[unit].min,
        notGreaterThanOrEqualTo: getTranslatedText(
          intl,
          'admin.policyManagement.patch.reboot.activeUser.schedule.errorMsg'
        )
      }
    }),
    intervalUnit: plaintextValidator(config),
    noOfTimes: numberValidator(config)
  };
};

export { loggedInUserScheduleValidation };
